import { Controller } from "@hotwired/stimulus"
import { showBlock, hide_messages } from "lib/helpers"

// account-managements--demo on `app/views/accounts/new_demo_account.haml`.
export default class extends Controller {
  static targets = ["createForm", "demoWrapper", "errorBlock"]

  connect() {
    if (!this.hasCreateFormTarget) return
    this.#initCreateDemoAccountForm()
  }

  disconnect() {
    if (this.hasCreateFormTarget) $(this.createFormTarget).ajaxFormUnbind()
  }

  #initCreateDemoAccountForm() {
    const errorSelector = this.hasErrorBlockTarget ? `#${this.errorBlockTarget.id}` : "#new-demo_account-errors"

    $(this.createFormTarget).ajaxForm({
      dataType: "json",
      success: (response) => {
        if (response.success) {
          hide_messages()
          if (this.hasDemoWrapperTarget) {
            this.demoWrapperTarget.innerHTML = response.message
          }
        } else {
          const error = $(errorSelector)
          if (error.length === 1) {
            error.after(error.clone())
          }
          showBlock(errorSelector, response.message)
          $(this.createFormTarget).find("input[type='submit']").enable(true)
        }
      },
      error: () => {
        showBlock(errorSelector, "An error occurred during request")
      },
    })
  }
}
